import ApisServiceApp from '@api/ApisServiceApp'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'


export function getListCommonLog(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceApp.get('/common/filter-log', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
